export default class LabelsConfig {
    constructor(_config) {
        this.layers = [
            //Congress Labels
            {
                'id': 'fips-labels-congress',
                'type': 'symbol',
                'source': 'fips-labels-congress-source',
                // 'source-layer': `congress_us_centroids`,
                'source-layer': `congress_labels_us_centroids`,
                'minzoom': 8, //7
                'layout': {
                    // 'text-field': ['get', 'namelsad'],
                    // 'text-field': ['get', 'conglabel'],
                    'text-field': ['get', 'distname'],
                    'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                    'text-size': 16,
                    'text-justify': 'auto',
                    'text-font': [
                        'literal',
                        ['Lato Black Italic', 'Arial Unicode MS Regular']
                    ]
                },
                'paint': {
                    'text-halo-color': '#787878', //#fff
                    'text-halo-width': .75,
                    // 'text-color': '#fff',
                    'text-color': '#fff', //#787878
                    'text-opacity': 1 //Deprecated: this.opacitySlideValue
                },
                'params': {
                    beforeId: 'choropleth-label-placeholder', 
                }
            },
            //State Upper
            {
                'id': 'fips-labels-statelegupper',
                'type': 'symbol',
                'source': 'fips-labels-statelegupper-source',
                'source-layer': `stateupper_labels_us_centroids`,
                'minzoom': 9,
                'layout': {
                    'text-field': ['get', 'stateupperlabel'],
                    'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                    'text-size': 16,
                    'text-justify': 'auto',
                    'text-font': [
                        'literal',
                        ['Lato Black Italic', 'Arial Unicode MS Regular']
                    ]
                },
                'paint': {
                    'text-halo-color': '#787878', //#fff
                    'text-halo-width': .75,
                    // 'text-color': '#fff',
                    'text-color': '#fff', //#787878
                    'text-opacity': 1 //Deprecated: this.opacitySlideValue
                },
                'params': {
                    beforeId: 'choropleth-label-placeholder', 
                }
            },
            //State Lower
            {
                'id': 'fips-labels-stateleglower',
                'type': 'symbol',
                'source': 'fips-labels-stateleglower-source',
                'source-layer': `statelower_labels_us_centroids`,
                'minzoom': 10,
                'layout': {
                    'text-field': ['get', 'statelowerlabel'],
                    // 'text-field': ['get', 'distname'],
                    'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                    'text-size': 16,
                    'text-justify': 'auto',
                    'text-font': [
                        'literal',
                        ['Lato Black Italic', 'Arial Unicode MS Regular']
                    ]
                },
                'paint': {
                    'text-halo-color': '#787878', //#fff
                    'text-halo-width': .75,
                    // 'text-color': '#fff',
                    'text-color': '#fff', //#787878
                    'text-opacity': 1 //Deprecated: this.opacitySlideValue
                },
                'params': {
                    beforeId: 'choropleth-label-placeholder', 
                }
            },
        ]
    }
}